import DashboardsModify from './DashboardsModify';

export default DashboardsModify;
